/** Platform settings pset library id (matches @fulcrum/cdm-components `SVC_SETTING_LIB_ID`). */
export const FAVORITES_LIB_ID = '5ca2ba53-dcd4-4ae8-8f02-bd6398b00271';

/** Favorites property-set definition id (matches @fulcrum/cdm-components `SVC_FAVS_DEF_ID`). */
export const FAVORITES_DEF_ID = '874e552a-61ca-4e06-8601-aaeb1a79acce';

export const FAVORITES_SCHEMA_VERSION = 0;

export interface FavoritePropertiesPsetPath {
  link: string;
  libId: string;
  defId: string;
}

export function getFavoritePropertiesLink(
  userId: string,
  projectId: string
): string {
  return `frn:user:${encodeURIComponent(userId)}/tcproject:${encodeURIComponent(
    projectId
  )}`;
}

export function getFavoritePropertiesPath(
  userId: string,
  projectId: string
): FavoritePropertiesPsetPath {
  return {
    link: getFavoritePropertiesLink(userId, projectId),
    libId: FAVORITES_LIB_ID,
    defId: FAVORITES_DEF_ID,
  };
}
